// extracted by mini-css-extract-plugin
module.exports =  {"locationIcon":"location_input-module_locationIcon_d78b2"};